/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxmEventsV1PollServiceReceiveReceiveRequest, IxmEventsV1PollServiceReceiveResponse } from '@interxfi/types';

export const IXM_EVENTS_V1_POLL_SERVICE_RECEIVE_AUDIENCE = ['clearing', 'program'];

export async function ixmEventsV1PollServiceReceive(baseUrl: string | undefined, request?: IxmEventsV1PollServiceReceiveReceiveRequest, requestInit?: RequestInit): Promise<IxmEventsV1PollServiceReceiveResponse | undefined> { return makeRequest<IxmEventsV1PollServiceReceiveResponse, IxmEventsV1PollServiceReceiveReceiveRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/events/v1/receive', request, requestInit)); }

